"use client";

import {
  PAGE_GUTTER_DESKTOP,
  PAGE_GUTTER_MOBILE,
  PAGE_GUTTER_TABLET,
} from "@/app/layout/LayoutConstants";
import { Box, styled } from "@mui/material";

interface BoxWithGuttersProps {
  extraPaddingRight?: boolean;
  minPaddingRight?: boolean;
}

export const BoxWithGutters = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "extraPaddingRight" && prop !== "minPaddingRight",
})<BoxWithGuttersProps>(({ theme, extraPaddingRight, minPaddingRight }) =>
  theme.unstable_sx({
    paddingLeft: PAGE_GUTTER_DESKTOP,
    paddingRight: theme.spacing(
      PAGE_GUTTER_DESKTOP + (extraPaddingRight ? 16 : 0)
    ),
    [theme.breakpoints.down("lg")]: {
      paddingLeft: PAGE_GUTTER_TABLET,
      paddingRight: theme.spacing(
        PAGE_GUTTER_TABLET + (extraPaddingRight ? 18 : 0)
      ),
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: PAGE_GUTTER_MOBILE,
      paddingRight: theme.spacing(
        PAGE_GUTTER_MOBILE + (extraPaddingRight ? 26 : 0)
      ),
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: PAGE_GUTTER_MOBILE,
      paddingRight: PAGE_GUTTER_MOBILE,
    },
    ...(  minPaddingRight
      ? {
          paddingRight: 4,
        }
      : {}),
  })
);
